<template>
  <article class="buscausuario-item-wrapper">
    <component v-bind:is="tag">
      <i class="material-icons left">{{ usuario.icon }}</i>
      Login {{ usuario.login }}
    </component>

    <section v-if="hasServidorResponsavel" class="section">
      <component v-bind:is="sectionTag">Servidor responsável</component>
      <p><b>Nome:</b>&nbsp; {{ usuario.servidorResponsavel.nome }}</p>
      <p><b>CPF:</b>&nbsp; {{ usuario.servidorResponsavel.cpf }}</p>
    </section>
    <p v-else>Servidor responsável não encontrado.</p>
  </article>
</template>

<script>
export default {
  name: "BaseBuscaUsuarioItem",
  inheritAttrs: false,
  props: {
    tag: {
      type: String,
      default: "h3",
      validator: value =>
        ["h1", "h2", "h3", "h4", "h5", "h6"].indexOf(value) !== -1
    },

    value: Object
  },
  computed: {
    hasServidorResponsavel() {
      return !!this.usuario.servidorResponsavel;
    },
    sectionTag() {
      const level = window.parseInt(this.tag.substring(1));

      if (!window.isNaN(level)) {
        if (level < 6) {
          return "h" + (level + 1);
        } else {
          return "h6";
        }
      }

      return "h4";
    },
    usuario() {
      let servidorResponsavel = null;

      if (this.value.servidorResponsavel) {
        servidorResponsavel = {
          nome: this.value.servidorResponsavel.nome,
          cpf: this.value.servidorResponsavel.cpf
        };
      }

      return {
        id: this.value.id,
        login: this.value.nome,
        tipo: this.value.tipo === "PessoaFisica" ? "servidor" : "sistema",
        icon: this.value.tipo === "PessoaFisica" ? "account_circle" : "devices",
        servidorResponsavel
      };
    }
  }
};
</script>
